import { createApp } from "vue";
import App from "./App.vue";
import router from "@/assets/js/router/index";
import pinia from "./assets/js/store";
import { createHead } from "@vueuse/head";

import "./assets/css/morpheus-style.css";
// [앱 생성 실시]
const app = createApp(App);
const head = createHead();

// 라우터 사용
app.use(router);

app.use(pinia);

app.use(head);

app.mount("#app");
